import { markRaw, defineAsyncComponent } from 'vue';
import { useModalOverlayStore } from '@nuxt-common/atomic-ui/app/stores/useModalOverlayStore';
import { useDashboardStore } from '@/stores/useDashboardStore';

const useModal = () => {
  const dashboard = useDashboardStore();
  const modalOverlayStore = useModalOverlayStore();

  const showModal = async (id, title, component, width = '38rem', props = {}) => {
    await dashboard.setModalOverlay({
      id,
      width,
      title,
      component: markRaw(defineAsyncComponent(() => component)),
      props,
    });

    modalOverlayStore.setModalOverlayVisibility(id);
  };

  const toggleModal = (id) => {
    modalOverlayStore.setModalOverlayVisibility(id);
  };

  return { showModal, toggleModal };
};

export default useModal;
